export const LIMIT_PAGE_BREAK: number = 10

export const LIMIT_PAGE_BREAK_GRID_VIEW = 16
